import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createFriendAddOutbound } from '../../api/outbound/friendsOutbounds';
import { OpenModalContainer } from '../../components/openModalContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
export const AddFriendModal = ({ onClose }) => {
    const [username, setUsername] = useState('');
    const socketSend = useSocketSend();
    const onClickAdd = useCallback(() => {
        if (username) {
            socketSend(createFriendAddOutbound(username));
        }
        onClose(); // close automatically on any add action
    }, [onClose, socketSend, username]);
    const onKeyDown = useCallback((event) => {
        if (event.key === 'Enter') {
            onClickAdd();
        }
    }, [onClickAdd]);
    const onChangeUsername = (event) => {
        setUsername(event.target.value);
    };
    return (_jsx(OpenModalContainer, { title: 'Add Friend', onClose: onClose, children: _jsxs(DialogActions, { children: [_jsx(TextField, { type: 'text', variant: 'filled', fullWidth: true, label: 'Username', value: username, onChange: onChangeUsername, onKeyDown: onKeyDown }), _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickAdd, children: "Add" })] }) }));
};
